// extracted by mini-css-extract-plugin
export default {"tech":"Skill_tech__vfa4Z","image":"Skill_image__Vz17u","grayFilter":"Skill_grayFilter__XIWm0","skillName":"Skill_skillName__jhuQP"};